var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"lang":_vm.lang},scopedSlots:_vm._u([{key:"default",fn:function({component}){return [_c('component',{attrs:{"lang":_vm.lang},on:{"changeLang":_vm.changeLang}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }